import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { getHighLight } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/highLight',
  initialState: {
    data: {},
    isLoading: true,
    isFirstLoad: false,
  },
  reducers: {
    resetStore: (state) => {
      state.data = {}
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHighLight.pending, (state) => {
      state.isLoading = true
      state.data = {}
    })
    builder.addCase(getHighLight.fulfilled, (state, action) => {
      state.isLoading = false
      state.isFirstLoad = true
      state.data = action.payload || {}
    })
    builder.addCase(getHighLight.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
      state.isFirstLoad = true
    })
  },
})

export const selectHighLight = (state) => state[slice.name].data
export const selectIsLoadingHightLight = (state) => state[slice.name].isLoading
export const selectIsFirstLoad = (state) => state[slice.name].isFirstLoad

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
